import resize from "../resize";
import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);

const initBecomeSlider = (idx) => {
  const slider = document.querySelector(`[data-become-${idx}]`);
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        autoHeight: false,

        breakpoints: {
          0: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: `.youBecome-block__next-${idx}`,
          prevEl: `.youBecome-block__prev-${idx}`,
          disabledClass: "last",
        },
        pagination: {
          el: `.youBecome-block__pagination-${idx}`,
          clickable: true,
          type: "fraction",
          bulletActiveClass: "active",
        },
      });
    }
  }

 

  function destroy() {
    if (swiper) {      
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper () {
    window.innerWidth < 768
      ? init()
      : destroy();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initBecomeSlider;
